import { RENT_TYPE } from './rentType';

export const EULERIAN_ACCOMMODATION_TYPE = {
  [RENT_TYPE.ENTIRE_PROPERTY]: 'entire_property',
  [RENT_TYPE.BEDROOM]: 'private_bedroom',
  [RENT_TYPE.BED]: 'shared_bedroom'
};
